<template>
<footer class="sitewide-footer p-8 bg-gray-800">

    <!--
    <div class="flex justify-center items-center mb-12">
        <nav class="flex items-center top-menu">
            <div v-for="link in topMenu" class="mx-4 relative">
                <a class="menu-link droplet-link relative uppercase font-headline font-bold text-white text-xs tracking-wider" :href="link.href">
                    {{ link.name }}
                </a>
                <span class="accent absolute text-primary-400" aria-hidden="true">
                    <i class="fa-solid fa-droplet"></i>
                </span>
            </div>
        </nav>
    </div>
    -->

    <!--
    <div class="flex justify-center mb-8">
        <nav class="bottom-menu">
            <div v-for="link in bottomMenu" class="mx-4 relative">
                <Link class="menu-link relative uppercase font-headline font-bold text-primary-600 text-xs tracking-wider transition-colors hover:text-secondary-500 focus:text-secondary-500" :href="link.href">
                    {{ link.name }}
                </Link>
            </div>
        </nav>
    </div>
    -->

    <div class="flex flex-wrap -mx-4">
        <div class="w-full vt:w-1/3 px-4">
            <p class="text-gray-500 uppercase font-medium text-xs tracking-wider" v-html="footer.data.copyright"></p>
        </div>
        <div class="w-full vt:w-2/3 px-4 mt-8 vt:mt-0">
            <nav class="flex flex-wrap vt:justify-end">
                <SocialLinks :links="site.social_media"></SocialLinks>
                <div v-for="link in bottomMenu" class="vt:mr-8 w-full vt:w-auto relative">
                    <Link class="menu-link relative uppercase font-headline font-bold text-white text-xs tracking-wider transition-colors hover:text-secondary-500 focus:text-secondary-500" :href="link.href">
                        {{ link.name }}
                    </Link>
                </div>
            </nav>
        </div>
    </div>
        
</footer>
</template>

<script>

import SocialLinks from './Utilities/SocialLinks.vue';

export default {

    props: {
        context: {
            required: true
        },
        hideForm: {
            default: false
        }
    },

    setup(props) {
        return {
            topMenu: props.context.nav?.footer_menu || [],
            bottomMenu: props.context.nav?.footer_bottom_menu || [],
            ...props.context,
        }
    },

    components: {
        SocialLinks
    }

}
</script>
